import { Box, styled } from "@mui/material";

interface BackdropOverlayProps {
  $hidden?: boolean;
}

export const BackdropOverlay = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$hidden",
})<BackdropOverlayProps>(({ $hidden }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  zIndex: 9998,
  pointerEvents: "none",
  opacity: $hidden ? 0 : 1,
  transition: "opacity 0.3s ease-out",
}));

interface DragWidgetBoxProps {
  $hidden?: boolean;
}

export const DragWidgetBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$hidden",
})<DragWidgetBoxProps>(({ theme, $hidden }) => ({
  position: "fixed",
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#ec5858",
  color: theme.palette.common.white,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  cursor: "grab",
  zIndex: 9999,
  boxShadow: theme.shadows[2],
  opacity: $hidden ? 0 : 1,
  transition: "opacity 0.3s ease-out",
  fontSize: theme.typography.pxToRem(12),
}));

export const CloseButton = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "-8px",
  right: "-8px",
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  borderRadius: "50%",
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.error.main}`,
  color: theme.palette.error.main,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: theme.typography.pxToRem(12),
  fontWeight: "bold",
  padding: 0,
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
  },
}));

export const DragLabel = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));
